module.exports = __webpack_public_path__ + "static/media/tool_logo_nessus.8ed3098d.png";